import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import config from './config';

if (typeof document !== 'undefined' && config.env !== 'test') {
  i18n
    .use(LanguageDetector)
    .use(Backend);
}
if (!i18n.isInitialized && initReactI18next) {
  i18n
    .use(initReactI18next)
    .init({
      load: 'languageOnly',
      lowerCaseLng: true,
      fallbackLng: 'en',
      debug: config.env === 'development',
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}'
      },
      ns: 'translations',
      defaultNS: 'translations',
      interpolation: {
        escapeValue: false,
        formatSeparator: ','
      },
      react: {
        useSuspense: config.env !== 'test'
      }
    });
}

export default i18n;
